define([
    './_site'
], function(
    Site
) {
    var _self;
    // console.log('menu');

    // obj
    _self = {
        // toggle: function() {
        //     $('body').toggleClass('menu-active');
        // },
        // defaultFocus: function($menuItem) {
        //     var $item = $menuItem.parent(),
        //         $submenu = $item.find('.submenu'),
        //         menuItemClass = 'menu__item',
        //         menuItemClassActive = menuItemClass + '--active';
        //
        //     // reset others
        //     $('#menu').find('.' + menuItemClass).not($item).removeClass(menuItemClassActive);
        //
        //     // active item
        //     $item.addClass(menuItemClassActive);
        // },
        // defaultBlur: function() {
        //     var subMenuClass = 'submenu',
        //         menuItemClass = 'menu__item',
        //         menuItemClassActive = menuItemClass + '--active',
        //         $submenu = $('.' + subMenuClass),
        //         $item = $('.' + menuItemClassActive);
        //
        //     // remove active item
        //     $item.removeClass(menuItemClassActive);
        // },
        // responsiveClick: function($menuItem) {
        //     var $item = $menuItem.parent(),
        //         subMenuClass = 'submenu',
        //         menuItemClass = 'menu__item',
        //         menuItemClassActive = menuItemClass + '--active',
        //         $submenu = $item.find('.' + subMenuClass);
        //
        //     if (!$submenu.length) {
        //         return false;
        //     }
        //
        //     // reset others
        //     $('#menu').find('.' + menuItemClass).not($item).removeClass(menuItemClassActive);
        //     $('.' + subMenuClass).not($submenu).stop(true).slideUp(200);
        //
        //     // active item
        //     $item.toggleClass(menuItemClassActive);
        //
        //     // animate menu
        //     $submenu.stop(true).slideToggle(200);
        //
        //     return true;
        // },
        toggle: function() {
            var $body = $('body');

            // toggle header
            $body.toggleClass('header-active');

            // reset sublevels
            $body.removeClass('cart-active menu-active submenu-active');

            $('.menu__item.active').removeClass('active');

            clearTimeout(Site.timeout.toggleMenu);
            setTimeout(function () {
                // toggle menu animation class
                if ($body.hasClass('header-active')) {
                    $body.addClass('menu-active');
                }
            }, 300);
        },
        submenuToggle: function($el) {
            var $item = $el.closest('.menu__item');

            $item.toggleClass('active');
            $('body').toggleClass('submenu-active');
        },
        defaultFocus: function($menuItem) {
            var $item = $menuItem.parent(),
                menuItemClass = 'menu__item',
                menuItemClassHover = menuItemClass + '--hover';

            // reset others
            $('#menu').find('.' + menuItemClass).not($item).removeClass(menuItemClassHover);

            // active item
            $item.addClass(menuItemClassHover);
        },
        defaultBlur: function() {
            var menuItemClass = 'menu__item',
                menuItemClassHover = menuItemClass + '--hover',
                $item = $('.' + menuItemClassHover);

            // remove active item
            $item.removeClass(menuItemClassHover);
        },
        responsiveHideMenu: function(classes) {
            $('body').removeClass('header-active menu-active submenu-active');
        },
        responsiveMenu: function(flag) {
            var $menu = $('#menu'),
                submenuClass = 'menu__submenu',
                menuItemClass = 'menu__item',
                menuItemClassActive = menuItemClass + '--active',
                menuNavClass = 'menu-nav',
                menuNavClassDefault = menuNavClass + '--default',
                menuNavClassResponsive = menuNavClass + '--responsive';

            if (flag) {
                $menu.removeClass(menuNavClassDefault).addClass(menuNavClassResponsive);
            } else {
                $menu.removeClass(menuNavClassResponsive).addClass(menuNavClassDefault);
                // $menu.find('.' + menuItemClass).removeClass(menuItemClassActive);
                $menu.find('.' + submenuClass).css({
                    display: ''
                });
            }
        },
        responsiveHeader: function(flag) {
            if (flag) {
                $(window).off('.affix');
                $("#header").removeClass("affix affix-top affix-bottom").removeData("bs.affix");
            } else {
                $('#header').affix({
                    offset: {
                        top: 110
                    }
                });
            }
        },
        resize: function(event) {
            var $window = $(window),
                breakpoints = Site.breakpoints;

            // md
            if ($window.width() < breakpoints.md) {
                _self.responsiveMenu(true);
                _self.responsiveHeader(true);
            } else {
                _self.responsiveMenu(false);
                _self.responsiveHeader(false);

                _self.responsiveHideMenu();
            }
        }
    };


    // -------------------
    // BINDS
    // -------------------

    // ---------------- toggle menu
    $('[data-menu-toggle]').on('click.menu', function(event) {
        event.preventDefault();
        _self.toggle();
    });

    // ---------------- menu (default)
    $('#header').on('focusin.menu mouseenter.menu', '.menu-nav--default .menu__link', function(event) {
        _self.defaultFocus($(this));
    });
    $('#header').on('mouseleave.menu', '.menu-nav--default .menu', function(event) {
        _self.defaultBlur();
    });

    // ---------------- menu (responsive)
    // $('#header').on('click.menu', '.menu-nav--responsive .menu__link', function(event) {
    //     if (_self.responsiveClick($(this))) {
    //         event.preventDefault();
    //     }
    // });


    // ---------------- submenu
    $('body').on('click.menu', '.menu-nav--responsive [data-submenu-toggle]', function(event) {
        event.preventDefault();
        _self.submenuToggle($(this));
    });

    // ---------------- window events
    $(window).on('resize.menu', function() {
        clearTimeout(Site.timeout.menuResize);
        Site.timeout.menuResize = setTimeout(function () {
            _self.resize();
        }, 100);
    });
    $(window).triggerHandler('resize.menu');

    return _self;
});
